import { useMemo, useState } from "react";
import {
  AuditReportPresetKey,
  CUSTOM_PERIOD,
  presetsForReport,
  resolveAuditReportPreset,
} from "../utils/constants/audit-report-constants";

const startOfToday = (): Date => {
  const date = new Date();
  date.setHours(0, 0, 0, 0);
  return date;
};

export type AttendancePeriodSelection = AuditReportPresetKey | typeof CUSTOM_PERIOD;

export const useAttendancePeriod = () => {
  const today = useMemo(startOfToday, []);
  const presets = useMemo(() => presetsForReport(["week", "month"]), []);
  const [period, setPeriod] = useState<AttendancePeriodSelection | null>(null);
  const [dateFrom, setDateFrom] = useState<Date | null>(null);
  const [dateTo, setDateTo] = useState<Date | null>(null);

  const applyPreset = (preset: AuditReportPresetKey) => {
    const range = resolveAuditReportPreset(preset, today);
    setPeriod(preset);
    setDateFrom(range.dateFrom);
    setDateTo(range.dateTo);
  };

  const enableCustomPeriod = () => setPeriod(CUSTOM_PERIOD);

  const handleDateFromChange = (date: Date | null) => {
    setDateFrom(date);
    if (date && dateTo && dateTo.getTime() < date.getTime()) {
      setDateTo(date);
    }
  };

  const handleDateToChange = (date: Date | null) => {
    setDateTo(date);
    if (date && dateFrom && dateFrom.getTime() > date.getTime()) {
      setDateFrom(date);
    }
  };

  const reset = () => {
    setPeriod(null);
    setDateFrom(null);
    setDateTo(null);
  };

  return {
    today,
    presets,
    period,
    dateFrom,
    dateTo,
    applyPreset,
    enableCustomPeriod,
    handleDateFromChange,
    handleDateToChange,
    reset,
  };
};
